<template>
    <div class="errorPage">
      <div class="errorPage__container" style="max-width:  800px;">

        <h2 class="errorPage__title sv-text-reset">🛠 System Maintenance is in Progress</h2>
        <p class="errorPage__paragraph sv-text-reset">
          Please be advised that there is scheduled maintenance in progress!
          During the maintenance, some of our users might experience some problems with their Dashboard. But this should not affect the functioning of your websites. They are working as usual.
          We apologize for any inconvenience!
          If you have any questions, please contact us via our support chat.
        </p>
      </div>
    </div>
</template>
<script>
export default {
  name: 'Maintenance'
}
</script>
